import { z } from "zod";

import { ForenkletEllerDetaljertEnum } from "../../reportEnums";

export const ZForenkletEllerDetaljertEnumSchema = z.nativeEnum(ForenkletEllerDetaljertEnum).nullable();
